export default '/:locale(ar|en)?/:trackId/:shopSearchString/t-s/';
